import { render, staticRenderFns } from "./DealerStatusDetails.vue?vue&type=template&id=12fec690&scoped=true&"
import script from "./DealerStatusDetails.vue?vue&type=script&lang=js&"
export * from "./DealerStatusDetails.vue?vue&type=script&lang=js&"
import style0 from "./DealerStatusDetails.vue?vue&type=style&index=0&id=12fec690&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12fec690",
  null
  
)

export default component.exports